import { parse } from 'hub-http/helpers/params';
import enviro from 'enviro';

const getQueryParam = param => {
  // Accessing `window.top` throws when we're on a
  // different domain (e.g. Wordpress)
  try {
    return parse(window.top.location.search.substring(1))[param];
  } catch (_) {
    return '';
  }
};

export const HAS_ASSIGNABLE_OVERRIDE = enviro.isQa() && getQueryParam('assignable') === 'true';
export const HAS_UNASSIGNABLE_OVERRIDE = enviro.isQa() && getQueryParam('assignable') === 'false';
export const HAS_RETAIL_OVERRIDE = enviro.isQa() && getQueryParam('isRetail') === 'true';
export const HAS_NOT_RETAIL_OVERRIDE = enviro.isQa() && getQueryParam('isRetail') === 'false';
export const HAS_FREE_OVERRIDE = enviro.isQa() && getQueryParam('isFree') === 'true';
export const HAS_PAID_OVERRIDE = enviro.isQa() && getQueryParam('isFree') === 'false';